import { render, staticRenderFns } from "./JsonBrowserNode.vue?vue&type=template&id=4a10dfc7&"
import script from "./JsonBrowserNode.vue?vue&type=script&lang=js&"
export * from "./JsonBrowserNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports